var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettingsStep = function SvgSettingsStep(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m27.135 26.89.01.06.025.025z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m27.135 26.89.01.06.025.025zM50.145 18.8v34.88l-10 5V23.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m50.145 18.8-10 5-2.765-1.595-4.735-2.735-.13-.075-12.765-7.37-10-5.775 10-5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m37.38 22.205-4.735-2.735-.13-.075-12.765-7.37-10-5.775v34.88l30.395 17.55V23.8zm-6.1 13.915c0 .345-.02.705-.07 1.08l-.015.13.56.88.405.635.98 1.545-1.69 2.32L29 40.425c-.31.08-.61.12-.905.13a7 7 0 0 1-.725-.025l-.225-.015-.51 2.61-3.375-1.95-.505-3.195a5 5 0 0 1-.225-.245q-.389-.411-.725-.815c-.3-.345-.6-.74-.91-1.175l-1.145-.255-1.305-.29-1.69-4.27 1.945-.815a12 12 0 0 1-.085-1.31c0-.39.03-.79.085-1.21l-1.945-3.06 1.69-2.315 1.025.955.28.26 1.145 1.07c.31-.08.61-.125.91-.13q.441-.014.95.04l.505-2.615 2.19 1.265 1.07.62.115.065.335 2.09.02.13.025.155.12.765.035.085q.489.519.925 1.03c.295.35.595.74.905 1.18l2.45.54 1.275 3.225.015.035.025.065.27.68.105.265-.21.09-1.735.725c.06.485.085.92.085 1.31"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M28.325 34.415q.001.451-.08.82c-.13.61-.42 1.045-.87 1.32l-.015.01-.215.105q-.726.309-1.64-.065a3.4 3.4 0 0 1-.55-.265c-.69-.395-1.305-.965-1.85-1.695a9.3 9.3 0 0 1-.825-1.36c-.47-.955-.705-1.875-.705-2.77q-.001-1.604.995-2.165.99-.57 2.385.24 1.275.736 2.22 2.245l.165.27c.225.385.41.77.555 1.145.29.735.435 1.46.435 2.165zM19.47 23.175l-2.715 1.36 1.69-2.315z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m26.52 23.685-6.77 3.385-1.05.525-1.945-3.06 2.715-1.36.28.26 1.145 1.07c.31-.08.61-.125.91-.13q.441-.014.95.04l2.695-1.35zM33.035 33.73l-.15.075-5.51 2.75c.45-.275.74-.71.87-1.32q.081-.369.08-.82c0-.705-.145-1.43-.435-2.165a8 8 0 0 0-.555-1.145l-.165-.27q-.945-1.509-2.22-2.245-1.395-.81-2.385-.24l4.295-2.15.155-.075.12.765.01.06.025.025q.489.519.925 1.03c.295.35.595.74.905 1.18l2.45.54 1.275 3.225.015.035.025.065zM33.14 40.39l-1.69 2.32L29 40.425l3.16-1.58z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M32.16 38.845 29 40.425c-.31.08-.61.12-.905.13a7 7 0 0 1-.725-.025l-.12-.07 4.505-2.25z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m31.755 38.21-4.505 2.25-.105.055-.51 2.61-3.375-1.95 2.8-1.4 5.15-2.575-.015.13zM25.5 36.605l-2.64 1.32-.105.055a5 5 0 0 1-.225-.245c-.26-.276-.5-.545-.725-.816-.3-.344-.6-.74-.91-1.174l2.205-1.1c.545.73 1.16 1.3 1.85 1.694.19.11.37.2.55.266"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m23.1 34.645-2.205 1.1-1.145-.255-1.305-.29 1.305-.65 2.525-1.265a9.287 9.287 0 0 0 .825 1.36M26.99 25.97l-.185.09-7.055 3.53-1.05.526a12 12 0 0 1-.085-1.31c0-.39.03-.79.085-1.21l1.05-.526 6.77-3.384.115.064.335 2.09z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m27.015 26.125-.155.075-4.295 2.15q-.996.561-.995 2.165c0 .895.235 1.815.705 2.77L19.75 34.55l-1.305.65-1.69-4.27 1.945-.815 1.05-.525 7.055-3.53.185-.09zM25.45 23.065l-2.695 1.35.505-2.615zM32.93 34.085l-1.735.725c.06.485.085.92.085 1.31 0 .345-.02.705-.07 1.08l-5.15 2.575-2.8 1.4-.505-3.195.105-.055 2.64-1.32q.914.374 1.64.065l.215-.105.015-.01 5.51-2.75.15-.075.105.265-.21.09z"
  })));
};
export default SvgSettingsStep;